export default "__VITE_ASSET__DNUdQX3___"